import * as React from 'react';
export var IconMagnifyingglassAiSparkle = React.forwardRef(function IconMagnifyingglassAiSparkle({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M7.217 2.007a.75.75 0 0 1 .077 1.498 4 4 0 1 0 4.067 5.043.75.75 0 1 1 1.447.393 5.496 5.496 0 0 1-.928 1.878l1.9 1.9a.75.75 0 1 1-1.06 1.061l-1.9-1.9a5.497 5.497 0 0 1-2.191 1.003 5.503 5.503 0 0 1-6.583-4.675 5.5 5.5 0 0 1 5.17-6.201ZM14.385.075c.179-.178.478-.005.413.24l-.354 1.326a1.978 1.978 0 0 0 .511 1.906l.97.972c.178.179.005.479-.24.414l-1.325-.354a1.978 1.978 0 0 0-1.907.51l-.971.97c-.18.18-.48.006-.414-.239l.353-1.326a1.979 1.979 0 0 0-.51-1.907l-.97-.972c-.178-.179-.005-.478.239-.413l1.326.354a1.979 1.979 0 0 0 1.907-.511l.972-.97Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M7.828 4.565a6.496 6.496 0 0 1 3.524-.519.75.75 0 1 1-.196 1.487 4.997 4.997 0 0 0-4.804 2.169 5.009 5.009 0 0 0-.195 5.272 5.004 5.004 0 0 0 4.633 2.517 4.998 4.998 0 0 0 4.31-3.037.75.75 0 0 1 1.38.587 6.509 6.509 0 0 1-.885 1.49l4.185 4.19a.75.75 0 1 1-1.06 1.059l-4.185-4.188a6.498 6.498 0 0 1-10.53-5.338 6.508 6.508 0 0 1 3.823-5.69ZM20.02 2.074c.179-.18.48-.006.415.239l-.564 2.113a1.985 1.985 0 0 0 .513 1.912l1.543 1.55c.178.179.005.478-.24.413l-2.11-.563a1.983 1.983 0 0 0-1.912.512l-1.547 1.545c-.18.18-.48.005-.415-.24l.564-2.112a1.986 1.986 0 0 0-.513-1.913L14.21 3.982c-.179-.18-.005-.48.24-.415l2.11.563a1.982 1.982 0 0 0 1.912-.512l1.547-1.544Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M7.828 4.565a6.496 6.496 0 0 1 3.524-.519.75.75 0 1 1-.196 1.487 4.997 4.997 0 0 0-4.804 2.169 5.009 5.009 0 0 0-.195 5.272 5.004 5.004 0 0 0 4.633 2.517 4.998 4.998 0 0 0 4.31-3.037.75.75 0 0 1 1.38.587 6.509 6.509 0 0 1-.885 1.49l4.185 4.19a.75.75 0 1 1-1.06 1.059l-4.185-4.188a6.498 6.498 0 0 1-10.53-5.338 6.508 6.508 0 0 1 3.823-5.69ZM20.02 2.074c.179-.18.48-.006.415.239l-.564 2.113a1.985 1.985 0 0 0 .513 1.912l1.543 1.55c.178.179.005.478-.24.413l-2.11-.563a1.983 1.983 0 0 0-1.912.512l-1.547 1.545c-.18.18-.48.005-.415-.24l.564-2.112a1.986 1.986 0 0 0-.513-1.913L14.21 3.982c-.179-.18-.005-.48.24-.415l2.11.563a1.982 1.982 0 0 0 1.912-.512l1.547-1.544Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
